// GENERATED FILE — DO NOT EDIT.
// Source: shared/taxonomy/expense_categories.v1.json
// Regenerate: node scripts/sync_taxonomy.mjs
// A backend test (tests/test_taxonomy_registry.py) fails the build if this file
// is stale, so the engine, the picker and the tests always read one list.
export const TAXONOMY = {
  "taxonomy_version": "interim-27.1",
  "status": "interim",
  "note": "Interim canonical expense taxonomy for Phase 1. Single source of truth for the engine, the picker and the tests. Replaced by the versioned registry table in the Financial Core Architecture 1.0 engine, at which point `excluded_from_spending` becomes a component rule rather than a category flag.",
  "categories": [
    {
      "id": "Food & Dining",
      "label": "Food & Dining",
      "group": "daily_living",
      "excluded_from_spending": false
    },
    {
      "id": "Groceries",
      "label": "Groceries",
      "group": "daily_living",
      "excluded_from_spending": false
    },
    {
      "id": "Fuel",
      "label": "Fuel",
      "group": "daily_living",
      "excluded_from_spending": false
    },
    {
      "id": "Transport",
      "label": "Transport",
      "group": "daily_living",
      "excluded_from_spending": false
    },
    {
      "id": "Car Maintenance",
      "label": "Car Maintenance",
      "group": "daily_living",
      "excluded_from_spending": false
    },
    {
      "id": "Utilities",
      "label": "Utilities",
      "group": "daily_living",
      "excluded_from_spending": false
    },
    {
      "id": "Shopping",
      "label": "Shopping",
      "group": "daily_living",
      "excluded_from_spending": false
    },
    {
      "id": "Medical",
      "label": "Medical",
      "group": "daily_living",
      "excluded_from_spending": false
    },
    {
      "id": "Personal Care",
      "label": "Personal Care",
      "group": "daily_living",
      "excluded_from_spending": false
    },
    {
      "id": "Housing",
      "label": "Housing",
      "group": "home",
      "excluded_from_spending": false
    },
    {
      "id": "Home Maintenance",
      "label": "Home Maintenance",
      "group": "home",
      "excluded_from_spending": false
    },
    {
      "id": "Education",
      "label": "Education",
      "group": "family",
      "excluded_from_spending": false
    },
    {
      "id": "Childcare",
      "label": "Childcare",
      "group": "family",
      "excluded_from_spending": false
    },
    {
      "id": "Entertainment",
      "label": "Entertainment",
      "group": "lifestyle",
      "excluded_from_spending": false
    },
    {
      "id": "Travel",
      "label": "Travel",
      "group": "lifestyle",
      "excluded_from_spending": false
    },
    {
      "id": "Subscriptions",
      "label": "Subscriptions",
      "group": "lifestyle",
      "excluded_from_spending": false
    },
    {
      "id": "Hobbies",
      "label": "Hobbies",
      "group": "lifestyle",
      "excluded_from_spending": false
    },
    {
      "id": "Gifts",
      "label": "Gifts",
      "group": "lifestyle",
      "excluded_from_spending": false
    },
    {
      "id": "Loan Payment",
      "label": "Loan Payment",
      "group": "financial",
      "excluded_from_spending": false
    },
    {
      "id": "Insurance",
      "label": "Insurance",
      "group": "financial",
      "excluded_from_spending": false
    },
    {
      "id": "Taxes",
      "label": "Taxes",
      "group": "financial",
      "excluded_from_spending": false
    },
    {
      "id": "Fees & Charges",
      "label": "Fees & Charges",
      "group": "financial",
      "excluded_from_spending": false
    },
    {
      "id": "Transfers",
      "label": "Transfers",
      "group": "financial",
      "excluded_from_spending": true
    },
    {
      "id": "Investments",
      "label": "Investment contribution",
      "group": "investing",
      "excluded_from_spending": true
    },
    {
      "id": "Business Expenses",
      "label": "Business Expenses",
      "group": "work",
      "excluded_from_spending": false
    },
    {
      "id": "Giving",
      "label": "Giving",
      "group": "giving",
      "excluded_from_spending": false
    },
    {
      "id": "Miscellaneous",
      "label": "Miscellaneous",
      "group": "other",
      "excluded_from_spending": false
    }
  ],
  "groups": [
    {
      "key": "daily_living",
      "label": "Daily Living"
    },
    {
      "key": "home",
      "label": "Home"
    },
    {
      "key": "family",
      "label": "Family"
    },
    {
      "key": "lifestyle",
      "label": "Lifestyle"
    },
    {
      "key": "financial",
      "label": "Financial"
    },
    {
      "key": "investing",
      "label": "Investing"
    },
    {
      "key": "work",
      "label": "Work"
    },
    {
      "key": "giving",
      "label": "Giving"
    },
    {
      "key": "other",
      "label": "Other"
    }
  ],
  "retired_subcategories": [
    {
      "parent": "Transport",
      "subcategory": "Vehicle Maintenance",
      "merged_into_category": "Car Maintenance"
    }
  ]
};

export const TAXONOMY_VERSION = TAXONOMY.taxonomy_version;

export const CATEGORY_DISPLAY_LABELS = Object.fromEntries(
  TAXONOMY.categories.map((c) => [c.id, c.label]),
);

export const categoryLabel = (id) => CATEGORY_DISPLAY_LABELS[id] || id;

export const NON_SPENDING_CATEGORIES = new Set(
  TAXONOMY.categories.filter((c) => c.excluded_from_spending).map((c) => c.id),
);

export const EXPENSE_CATEGORY_GROUPS_FROM_TAXONOMY = TAXONOMY.groups
  .map((g) => ({
    key: g.key,
    label: g.label,
    items: TAXONOMY.categories.filter((c) => c.group === g.key).map((c) => c.id),
  }))
  .filter((g) => g.items.length > 0);

export default TAXONOMY;
